const React = require('react');
const { Global, css} = require('@emotion/react');

const GlobalStyles = () => (
    <Global styles={css`
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
    
        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
            background-color: white;
            min-height: 100vh;
            color: #333;
            line-height: 1.6;
            padding: 40px 20px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    
        .challenge-container {
            max-width: 1200px;
            margin: 60px auto 0;
            text-align: left;
        }
    
        .fingerprint-loading {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 1rem;
            width: fit-content;
            padding: 0px 0.5rem;
            border-radius: 3px;
            border: 1px solid #e1e1e1;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            background-color: whitesmoke;
            min-width: 250px;
        }
        .fingerprint-error {
            color: #dc3545; 
            display: flex;
            align-items: center;
            align-content: center;
            justify-content: flex-start;
        }
        .fingerprint-status {
            display: flex;
            justify-content: flex-start;
        }
    
    
        .site-name {
            font-size: 2rem;
            font-weight: 600;
            color: #333;
            margin-bottom: 16px;
            letter-spacing: -0.02rem;
        }
    
        .main-heading {
            font-size: 1.5rem;
            font-weight: 500;
            color: #333;
            margin-bottom: 40px;
        }
    
        .verification-section {
            margin-bottom: 40px;
        }
    
        #recaptcha-container {
            display: flex;
            justify-content: flex-start;
            min-height: 100px;
        }
    
        .security-message {
            color: #666;
            font-size: 1rem;
            margin-bottom: 32px;
            line-height: 1.6;
        }
        /* .expandable-section {
            border
        } */
    
    
        .status-text {
            font-size: 0.9rem;
            color: #666;
            margin-top: 16px;
            display: flex;
            align-items: center;
            gap: 8px;
        }
    
        .status-text.loading {
            color: #666;
        }
        .status-text.success {
            color: #0d7377;
        }
    
        .status-text.error {
            color: #d73502;
        }
    
        .loading-spinner {
            width: 14px;
            height: 14px;
            border: 2px solid #e0e0e0;
            border-top: 2px solid #666;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }
    
        @keyframes spin {
            0% { transform: rotate(0deg);}
            100% {transform: rotate(360deg);}
        }
    
        .hidden {
            display: none;
        }
    
       
        .lds-spinner,
        .lds-spinner div,
        .lds-spinner div:after {
            box-sizing: border-box;
        }
        .lds-spinner {
            color: currentColor;
            display: inline-block;
            position: relative;
            width: 80px;
            height: 80px;
            scale: 0.7;
        }
        .lds-spinner div {
            transform-origin: 40px 40px;
            animation: lds-spinner 1.2s linear infinite;
        }
        .lds-spinner div:after {
            content: " ";
            display: block;
            position: absolute;
            top: 3.2px;
            left: 36.8px;
            width: 6.4px;
            height: 17.6px;
            border-radius: 20%;
            background: currentColor;
        }
        .lds-spinner div:nth-of-type(1) {
            transform: rotate(0deg);
            animation-delay: -1.1s;
        }
        .lds-spinner div:nth-of-type(2) {
            transform: rotate(30deg);
            animation-delay: -1s;
        }
        .lds-spinner div:nth-of-type(3) {
            transform: rotate(60deg);
            animation-delay: -0.9s;
        }
        .lds-spinner div:nth-of-type(4) {
            transform: rotate(90deg);
            animation-delay: -0.8s;
        }
        .lds-spinner div:nth-of-type(5) {
            transform: rotate(120deg);
            animation-delay: -0.7s;
        }
        .lds-spinner div:nth-of-type(6) {
            transform: rotate(150deg);
            animation-delay: -0.6s;
        }
        .lds-spinner div:nth-of-type(7) {
            transform: rotate(180deg);
            animation-delay: -0.5s;
        }
        .lds-spinner div:nth-of-type(8) {
            transform: rotate(210deg);
            animation-delay: -0.4s;
        }
        .lds-spinner div:nth-of-type(9) {
            transform: rotate(240deg);
            animation-delay: -0.3s;
        }
        .lds-spinner div:nth-of-type(10) {
            transform: rotate(270deg);
            animation-delay: -0.2s;
        }
        .lds-spinner div:nth-of-type(11) {
            transform: rotate(300deg);
            animation-delay: -0.1s;
        }
        .lds-spinner div:nth-of-type(12) {
            transform: rotate(330deg);
            animation-delay: 0s;
        }
        @keyframes lds-spinner {
            0% {
                opacity: 1;
            }
            100% {
                opacity: 0;
            }
        }
    
    
    
        /* Success checkmark */
    
        .success-check {
            display: inline-block;
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 50%;
            background: #28a745;
            color: white;
            font-size: 1.2rem;
            line-height: 1.5rem;
            margin-right: 8px;
        }
    
        .success-check::before {
            content: '✓';
            display: flex;
            justify-content: center;
        }
    
        #explain-message {
            font-weight: 400;
            font-size: 1.5rem;
            padding: 2.5rem 1rem 0rem 0rem;
            color: #666;
        }
    
        #explain-message.current-host {
            font-weight: 450;
        }
    
        .error-icon {
            display: inline-block;
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 50%;
            background: #dc3545;
            color: white;
            font-size: 1.2rem;
            line-height: 1.5rem;
            margin-right: 8px;
        }
    
        .error-icon::before {
            content: '✕';
            display: flex;
            justify-content: center;
        }
    
        @media (max-width: 768px) {
            .challenge-container{
                margin: 20px auto 0;
                padding: 0 16px;
            }
    
            .site-name {
                font-size: 1.6rem;
            }
    
            .main-heading{
                font-size: 1.6rem;
            }
    
            #recaptcha-container {
                padding: 16px;
            }
        }
    `}/>
);
module.exports = GlobalStyles;